import { every, first, isEmpty } from 'lodash/fp';
import { SubstituteType } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { formatNumber } from '@optimus-web/core';

export const processError =
    (Component: $TSFixMe) =>
    ({ errors, touched, groupSeparator, decimalSeparator, ...other }: $TSFixMe) => {
        let localizedError;

        if (touched && !isEmpty(errors)) {
            const error = first(errors);
            // @ts-expect-error $TSFixMeError: Property 'textKey' does not exist on type 'unknown'.
            const { textKey, substitutesToFormat } = error;
            // @ts-expect-error $TSFixMeError: Property 'substitutes' does not exist on type 'unknown'.
            let { substitutes } = error;

            if (!isEmpty(substitutesToFormat)) {
                every((substituteToFormat) => {
                    const { name: substituteName, value: substituteValue, type: substituteType } = substituteToFormat;
                    switch (substituteType) {
                        case SubstituteType.Number: {
                            const { value: formattedValue } = formatNumber({
                                vs: { value: substituteValue, selection: { start: 0, end: 0 } },
                                groupSize: 3,
                                groupSeparator,
                                decimalSeparator,
                            });
                            substitutes = {
                                ...substitutes,
                                [substituteName]: formattedValue,
                            };
                            break;
                        }
                        default:
                            break;
                    }
                }, substitutesToFormat);
            }

            localizedError = <LocalizedText textKey={textKey} substitutes={substitutes} />;
        }

        return <Component {...other} error={localizedError} />;
    };
